export default __webpack_public_path__ + "static/media/left-square.0c6d7dfb.svg";